import { updateDarkMode } from '@/Support/Common/Functions/updateDarkMode'
import { useAppLayout } from '@/stores/appLayout'

export enum TypeScreenTheme {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

export const changeDarkMode = (newMode: string | TypeScreenTheme) => {
  switch (newMode) {
    case 'light':
      localStorage.theme = 'light'
      break

    case 'dark':
      localStorage.theme = 'dark'
      break

    case 'system':
      localStorage.removeItem('theme')
      break
  }

  const { setCurrentScreenMode } = useAppLayout()
  setCurrentScreenMode(newMode)

  updateDarkMode()
}
